import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from 'src/app/core/overlay';
import type { LastOrderItem } from 'src/app/core/services/menu-validators.service';

type RemovedItem = { item: LastOrderItem; motivo: string };

@Component({
	selector: 'app-removed-items-dialog',
	templateUrl: './removed-items-dialog.page.html',
	styleUrls: ['./removed-items-dialog.page.scss'],
})
export class RemovedItemsDialogPage implements OnInit {

	@Input('removedItems') removedItems: RemovedItem[] = [];
	@Input('hasValidItems') hasValidItems: boolean = false;

	constructor(public modalCtrl: ModalController) { }

	ngOnInit() {
	}

	async dismiss() {
		await this.modalCtrl.dismiss({
			'dismissed': true
		});
	}

}

